import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRouteMatch } from '@oceanjs/core';
import clsx from 'clsx';
import { useThemeValue } from '../../state/theme';
import { getFlexClasses } from '../../utils/getFlexClasses';
import { Flex } from '../Flex';
import { Link } from '../Link';
import { MainMenuItemContent } from './components/MainMenuItemContent';
/**
 * Main menu item, to be used inside the `MainMenu` component
 */
export const MainMenuItem = (props) => {
    const { to, icon, text, className, exact = false, children, suffix, forceSameWindow, forceExternal, } = props;
    const routeMatch = useRouteMatch(to);
    const isActive = routeMatch !== null && ((exact === true && routeMatch.isExact === true) || exact === false);
    const menuHoverClasses = useThemeValue('main-menu-item-hover', 'focus:bg-gray-100 hover:bg-gray-100');
    return (_jsxs("div", Object.assign({ className: "group" }, { children: [_jsx(Link, Object.assign({ to: to, className: clsx('p-2 border-l-8 group', getFlexClasses({ alignItems: 'center', justifyContent: 'between' }), menuHoverClasses, className), forceSameWindow: forceSameWindow, forceExternal: forceExternal }, { children: _jsx(MainMenuItemContent, { isActive: isActive, icon: icon, text: text, suffix: suffix }, void 0) }), void 0),
            _jsx(Flex, Object.assign({ column: true, className: clsx('text-sm', { hidden: !isActive }) }, { children: children }), void 0)] }), void 0));
};
//# sourceMappingURL=MainMenuItem.js.map